import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Si le back est de nouveau joignable, on ne reste pas sur /unavailable => retour à l'app. */
export const unavailableGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.backendReachable() ? router.createUrlTree(['/']) : true;
};
